import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import validateForm from '../../helpers/validateform';

import { UserService } from '../../services/user.service';

import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css'
})
  
export class ForgotPasswordComponent {
  forgotPwd!: FormGroup;
  errorMessage: string = '';
  successMessage: string = '';
  lang: any;
  language: any;
  
  constructor(private formBuilder: FormBuilder, private translate: TranslateService, private user: UserService) { }
  
  ngOnInit(): void {
    this.translate.addLangs(['en', 'jp']);

    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      this.lang = localStorage.getItem('site_lang') ?? 'jp';
      localStorage.setItem('site_lang', this.lang);
      this.translate.use(this.lang);
    }

    this.forgotPwd = this.formBuilder.group({
      loginID: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]]
    });
  }
  get f() { return this.forgotPwd.controls; }

  sendPwd() {
    // console.log(this.forgotPwd.value.password);
    if (this.forgotPwd.invalid) {
          validateForm.validateAllFormFields(this.forgotPwd);
          alert(this.translate.instant('PleaseFillFormCorrectly'));     
          return;
    }
    // console.log(this.lang);
    // return
    if (this.lang == 'en') {
      this.language = 1;
    } else {
      this.language = 2
    }

    const payLoad = {
      "loginId": this.forgotPwd.value.loginID,
      "email": this.forgotPwd.value.email,
      "LanguageType" : this.language
    }
    this.user.restPasswordRequest(payLoad, this.lang)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            this.successMessage = res.message;
            this.errorMessage = '';
            alert(res.message)
          } else {
            this.errorMessage = res.message;
            this.successMessage = '';
            alert(res.message)
          } 
        },
        error: (err: any) => {
          this.errorMessage = err.message;
          this.successMessage = '';
        }
    })
    
  }
}
